import { render, staticRenderFns } from "./PaginaDiccionarioRespuestas.vue?vue&type=template&id=6f5f736d"
import script from "./PaginaDiccionarioRespuestas.vue?vue&type=script&lang=js"
export * from "./PaginaDiccionarioRespuestas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports